/* Source: /tmp/jacbuilder-deploy-scratch/deploy-8asygg26/main.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import "./styles/global.css";
import "./styles/trace-tokens.css";
import { Router, Routes, Route } from "@jac/runtime";
import { TraceDashboard } from "./components/TraceDashboard.js";
function App() {
  return __jacJsx(Router, {}, [__jacJsx(Routes, {}, [__jacJsx(Route, {"path": "/", "element": __jacJsx(TraceDashboard, {}, [])}, [])])]);
}
const app = App;
/*jac:refresh-boundary*/;
export {app};
//# sourceMappingURL=main.js.map
